import { render, staticRenderFns } from "./RCsvupload.vue?vue&type=template&id=1b4cf6c2&scoped=true"
import script from "./RCsvupload.vue?vue&type=script&lang=js"
export * from "./RCsvupload.vue?vue&type=script&lang=js"
import style0 from "./RCsvupload.vue?vue&type=style&index=0&id=1b4cf6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4cf6c2",
  null
  
)

export default component.exports